<div *ngIf="filtersLoaded" class="custom-filters">
    <div>
        <mat-chip-list aria-orientation="horizontal">
            <!-- Filtros favoritos -->
            <ng-container *ngFor="let filter of favoriteFilters">
                <smt-search-widget-chip [filter]="filter" (filterChange)="onFilterChange($event)"
                    (submitQuery)="submitQuery()">
                </smt-search-widget-chip>
            </ng-container>
        </mat-chip-list>

        <div [ngClass]="!showAllFilters ? 'hide-favorites' : ''">
            <mat-divider class="content__divider"></mat-divider>

            <mat-chip-list aria-orientation="horizontal">
                <!-- Filtros adicionales -->
                <ng-container>
                    <ng-container *ngFor="let filter of otherFilters">
                        <smt-search-widget-chip [filter]="filter" (filterChange)="onFilterChange($event)"
                            (submitQuery)="submitQuery()">
                        </smt-search-widget-chip>
                    </ng-container>
                </ng-container>
            </mat-chip-list>
        </div>

        <!--<mat-chip-list aria-orientation="horizontal">
                <ng-container *ngIf="facetFiltersService.responseFacets && showContextFacets">
                    <ng-container *ngFor="let field of facetFiltersService.responseFacets">
                        <adf-search-facet-chip [field]="field"
                            [attr.data-automation-id]="'search-fact-chip-' + field.field"></adf-search-facet-chip>
                    </ng-container>
                </ng-container>
            </mat-chip-list>-->
    </div>

    <!-- Botón para mostrar/ocultar -->
    <button mat-icon-button *ngIf="otherFilters?.length > 0" (click)="toggleFilters()"
        [matTooltip]="showAllFilters ? ('ALDEN.FILTERS.SHOW_LESS' | translate) : ('ALDEN.FILTERS.SHOW_MORE' | translate)">
        <mat-icon fontSet="material-icons-outlined">{{ showAllFilters ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
</div>